// extracted by mini-css-extract-plugin
export default {"transparent-button":"TransparentButton_transparent-button__IDY7S","disabled-button":"TransparentButton_disabled-button__JvUGk"};